
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[slug]/reviews",
      function () {
        return require("private-next-pages/store/[slug]/reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[slug]/reviews"])
      });
    }
  